<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JAl9Kn/tc-custom/9781466821149.jpg?1731883558485" alt="This image is the cover for the book Walk to the End of the World, The Holdfast Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Walk to the End of the World, The Holdfast Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>The “devastatingly powerful” first novel in the acclaimed classic science fiction series The Holdfast Chronicles, from the award-winning author (<i>The Washington Post</i>).</b><br/><br/><b>Winner of the James Tiptree, Jr. Award</b><br/><br/><i>Walk to the End of the World</i> begins Suzy McKee Charnas’s incomparable epic tale of men and women, slavery and freedom, power and human frailty.<br/><br/>In a post-apocalyptic world, Alldera the Messenger is a slave among the Fems, in thrall to men whose own power is waning, until she escapes and is saved by a tribe of women whose strength and courage sustain her. <i>Walk to the End of the World</i> is old-school feminist science fiction at its most prophetic.<br/><br/><b>“Only one science fiction book in hundreds manages to convince the reader that it ever could have happened anywhere, and at least that few are worth reading at all. [Charnas has] created a future that is once believable and fascinating” —William S. Burroughs, author of <i>Naked Lunch</i></b><br/><br/><b>“One of the best books I’ve read this year.” —Dorothy Allison, <i>New York Times</i>–bestselling author of <i>Bastard Out of Carolina</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Suzy McKee Charnas
      </h2>
      
      <p class="authorDescription body article"><P><B>Suzy McKee Charnas </B>is the author of over a dozen works of science fiction, fantasy, and horror, including the Holdfast series from Tor Books and the Sorcery Hall series of books for young adults. She is the winner of the Hugo Award (for her short story "Boobs") and has won the James Tiptree, Jr. Award twice, once retrospectively for the first two Holdfast books and then for <I>The Conqueror's Child</I>, final volume of the Holdfast series. Her most recent book is <I>My Father's Ghost</I>, a narrative nonfiction work about her father's old age. She adapted her novel, <I>The Vampire Tapestry</I>, for the stage in the late 1990s. <br><br>She was born and brought up in New York City, the setting for the Sorcery Hall books, and she currently lives in Albuquerque, New Mexico.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?395a646f